var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.pageActionConfig, page: _vm.pageConfig }
      }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-6 col-sm-12" },
          [
            _c("filter-manager", {
              attrs: {
                "display-advanced": false,
                filters: _vm.filterManagerConfig
              },
              on: { search: _vm.onSearchHandler },
              model: {
                value: _vm.filtersSelected,
                callback: function($$v) {
                  _vm.filtersSelected = $$v
                },
                expression: "filtersSelected"
              }
            })
          ],
          1
        )
      ]),
      _c("separator", {
        staticClass: "mt-4 mb-5",
        attrs: { text: "Resultados" }
      }),
      !_vm.showNotFound
        ? _c("result-not-found")
        : [
            _c("board", {
              staticClass: "mb-4",
              attrs: { details: _vm.boardData }
            }),
            _vm.result.data && _vm.result.data.length > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col d-flex justify-content-end align-items-center mb-2"
                  },
                  [
                    _c("custom-link", {
                      staticClass: "justify-content-end font-14",
                      attrs: { icon: "fa fa-plus", text: "Expandir Todos" },
                      on: {
                        click: function($event) {
                          return _vm.checkUncheckHandler(true)
                        }
                      }
                    }),
                    _c("custom-link", {
                      staticClass: "justify-content-end font-14 ml-3",
                      attrs: { icon: "fa fa-minus", text: "Colapsar Todos" },
                      on: {
                        click: function($event) {
                          return _vm.checkUncheckHandler(false)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.result.data, function(resultItem, idx) {
              return _c(
                "callout",
                {
                  key: idx,
                  staticClass: "mb-3 callout__extended",
                  attrs: {
                    "border-color": "primary-15",
                    controlled: true,
                    "has-toggle": true,
                    opened: resultItem.isOpen
                  },
                  on: {
                    "click:open": function($event) {
                      return _vm.onOpenDetails(resultItem)
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "edition",
                        fn: function() {
                          return [
                            _c("div", { staticClass: "container-fluid p-2" }, [
                              _c(
                                "div",
                                { staticClass: "container-fluid bg-white" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mx-1" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row py-2 d-sm-none d-md-flex border-edition-header"
                                        },
                                        [
                                          _c("div", { staticClass: "col" }, [
                                            _c("span", [
                                              _vm._v("Servicio / Modalidad")
                                            ])
                                          ]),
                                          _c("div", { staticClass: "col" }, [
                                            _c("span", [
                                              _vm._v("Frecuencia / Duración")
                                            ])
                                          ]),
                                          _c("div", { staticClass: "col" }, [
                                            _c("span", [
                                              _vm._v("Transportación")
                                            ])
                                          ]),
                                          _c("div", { staticClass: "col" }, [
                                            _c("span", [_vm._v("Acción")])
                                          ])
                                        ]
                                      ),
                                      _vm._l(resultItem.items, function(
                                        item,
                                        itemIdx
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: itemIdx,
                                            staticClass: "row pt-1",
                                            class: {
                                              "border-bottom":
                                                itemIdx !=
                                                resultItem.items.length - 1
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-sm d-flex align-items-center pb-1"
                                              },
                                              [
                                                _c("div", [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.disciplineName
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            item.serviceModalityTypeName,
                                                          expression:
                                                            "item.serviceModalityTypeName"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "font-14 color-secondary-6 font-weight-normal"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.serviceModalityTypeName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-sm d-flex align-items-center pb-1"
                                              },
                                              [
                                                _c("div", [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.frequencyTypeName
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            item.durationTypeName,
                                                          expression:
                                                            "item.durationTypeName"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "font-14 color-secondary-6 font-weight-normal"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.durationTypeName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ])
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-sm d-flex align-items-center pb-1"
                                              },
                                              [
                                                _vm.isBECA(
                                                  item.peiTransportationName
                                                )
                                                  ? _c("transportation-type", {
                                                      attrs: {
                                                        "companion-flag":
                                                          item.companionFlag,
                                                        mileage: item.mileage,
                                                        "pei-transportation-name":
                                                          item.peiTransportationName,
                                                        "service-daily-cost":
                                                          item.serviceDailyCost
                                                      }
                                                    })
                                                  : _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.transportationMode(
                                                              item.peiTransportationName
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-sm d-flex align-items-center"
                                              },
                                              [
                                                _vm.enableMileageAction(
                                                  item.peiTransportationCode
                                                )
                                                  ? _c(
                                                      "action-button",
                                                      {
                                                        attrs: {
                                                          i:
                                                            "fas fa-file-search",
                                                          variant:
                                                            "outline-success"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.onDownloadMileageHandler(
                                                              item.peiId,
                                                              item.analysisServiceId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Ver Acuerdo/Millaje "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row pb-0 mb-0" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-2 d-md-flex rounded" },
                      [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("icon-view", {
                              staticClass: "icon-view__extended",
                              attrs: {
                                icon: "fas fa-user-shield",
                                "icon-background": "#fff",
                                "icon-color": "#FF7058",
                                "icon-size": "14px"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column justify-content-center"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "font-14 color-secondary-6" },
                              [_vm._v("Número de PEI:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-black font-16 font-weight-bold"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      resultItem.peiId.slice(0, 4) +
                                        "-" +
                                        resultItem.peiId.slice(4, 10)
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm d-flex flex-column justify-content-center"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "font-14 color-secondary-6" },
                          [_vm._v("Enmienda:")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  resultItem.generalRevisionNo
                                    .toString()
                                    .padStart(2, "0")
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm d-flex flex-column justify-content-center"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "font-14 color-secondary-6" },
                          [_vm._v(" Año Escolar Extendido: ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  resultItem.configExtendedSchoolYearFlag ===
                                    "1"
                                    ? "Si"
                                    : "No"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm border-right d-flex flex-column justify-content-center pr-0 my-2"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "font-14 color-secondary-6" },
                          [_vm._v("Fecha de Firma:")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("date")(resultItem.generalClosedDate)
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm pl-4 d-flex flex-column justify-content-center"
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "font-14 color-secondary-6" },
                          [_vm._v("Fecha de Inicio:")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("date")(
                                    resultItem.serviceAnalysisPlacementStartDate
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-sm-3 d-flex justify-content-center align-items-center"
                      },
                      [
                        _c(
                          "action-button",
                          {
                            attrs: {
                              i: "fas fa-print",
                              variant: "outline-success"
                            },
                            on: {
                              click: function($event) {
                                return _vm.onDownloadPeiReport(resultItem.peiId)
                              }
                            }
                          },
                          [_vm._v(" Reporte del PEI o PS ")]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }